// Works with dynamic content via event delegation
function initPageClick() {
  // If you have a stable wrapper, use it instead of document for better perf:
  // const root = document.querySelector('[data-product-list]');
  const root = document;

  root.addEventListener('click', (e) => {
    const product = e.target.closest('[data-product-grid]');
    if (!product || !root.contains(product)) return;

    // If you truly want to block multiple pushes for the same element in one session, keep this.
    // Otherwise remove this guard.
    if (product.classList.contains('initialised')) return;

    const page = product.getAttribute('data-page');
    const prodId = product.querySelector('.product-card')?.getAttribute('data-product-id');

    const url = new URL(location.href);
    if (page) url.searchParams.set('page', page);
    if (prodId) url.searchParams.set('product', prodId);

    history.pushState(null, document.title, url.href);

    product.classList.add('initialised');
  }, { passive: true });
}

// Load Previous Page

var loadButton = document.querySelector('.js-collection-load-previous');
let here = new URL(window.location.href);
var currentPage = parseInt(here.searchParams.get('page'));

if (loadButton != null) {

  loadButton.addEventListener('click', function() {

    loadButton.classList.add('page-loading');

      currentPage = currentPage - 1;
      here.searchParams.set('page', currentPage);


      fetch(here.href, {
        headers: {
            'Accept': 'text/html'
        }
      })
      .then(function(response) {
        return response.text()
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var html = doc.querySelector('.collection__cards');
        prodResize(html, 'loadMore');
         initPageClick();
        var heightBefore = document.querySelector("#collection-main > div.collection-products.collection-products--sort-enabled > div > div.o-layout__item.u-1\\/1 > div.collection__cards.o-layout.o-layout--small.o-layout--small\\@tab-down").offsetHeight;
        document.querySelector("#collection-main > div.collection-products.collection-products--sort-enabled > div > div.o-layout__item.u-1\\/1 > div.collection__cards.o-layout.o-layout--small.o-layout--small\\@tab-down").insertAdjacentHTML("afterbegin", html.innerHTML);
        var heightAfter = document.querySelector("#collection-main > div.collection-products.collection-products--sort-enabled > div > div.o-layout__item.u-1\\/1 > div.collection__cards.o-layout.o-layout--small.o-layout--small\\@tab-down").offsetHeight;
        const y = window.pageYOffset + (heightAfter - heightBefore);
        document.querySelector('html').scrollTop = y;
        loadButton.classList.remove('page-loading');

        // Initialise PDP with new products
        const forms = document.querySelectorAll('form[action^="/cart/add"]:not(.initialised)'); Array.from(forms).forEach((form) => window.ajaxCart.initForm(form) ); Array.from(forms).forEach((form) => form.classList.add('initialised') );
        collectionSpotsResize();
        CollectionGAEvents();
        quickbuyGA();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        if (currentPage <= 1) {
          loadButton.remove();
        }

      })

  }, false);

}

// Load Next Page

function fetchNextPage(isLast) {

  let btn = document.querySelector('.js-collection-load-next')
  btn.classList.add('page-loading');

  fetch(window.location.href, {
    headers: {
        'Accept': 'text/html'
    }
  })
  .then(function(response) {
    return response.text()
  })
  .then(function(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var html = doc.querySelector('.collection__cards');
    prodResize(html, 'loadMore');
    document.querySelector("#collection-main > div.collection-products.collection-products--sort-enabled > div > div.o-layout__item.u-1\\/1 > div.collection__cards.o-layout.o-layout--small.o-layout--small\\@tab-down").insertAdjacentHTML("beforeend", html.innerHTML);
    var loadedProducts = html.querySelectorAll('[data-product-grid]').length
    updateProductsLoaded(loadedProducts);
    const forms = document.querySelectorAll('form[action^="/cart/add"]:not(.initialised)'); Array.from(forms).forEach((form) => window.ajaxCart.initForm(form) ); Array.from(forms).forEach((form) => form.classList.add('initialised') );
    collectionSpotsResize();
    CollectionGAEvents();
    quickbuyGA();
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    btn.classList.remove('page-loading');
    initPageClick();
    if(isLast){btn.remove();};

  })

}

// PLP Function to check/toggle resize if previously selected ON LOAD

function toggleInit() {

  window.Shopify.ActiveProduct = []

  var activeProdTimer = null;
  window.addEventListener('scroll', function() {
      if(activeProdTimer !== null) {
          clearTimeout(activeProdTimer);        
      }
      activeProdTimer = setTimeout(function() {
        let scroll = window.scrollY;
        let elements = $("[data-product-grid]"); 
        let el;
        for (let i=0; i<elements.length; i++) {
            el = $(elements[i]);
            if (el.offset().top >= scroll && el.is(':visible')){
                window.Shopify.ActiveProduct = el;
                break;
            }
        }
      }, 100);
  }, false);

}

// One listener for all current/future .js-collection-load-next buttons
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.js-collection-load-next');
  if (!btn) return;                 // clicked something else
  if (btn.dataset.loading === '1') return; // simple guard against double-clicks
  btn.dataset.loading = '1';

  let here = new URL(window.location.href);
  const pagesCount = Number(
    document.querySelector('.collection-pagination')?.dataset.pages ?? 1
  );

  const currentPage = Number(here.searchParams.get('page') ?? 1);
  const nextPage = currentPage + 1;

  // Remove/disable when we hit the end
  if (nextPage >= pagesCount) {
    var isLast = true
  } else {
    var isLast = false
  }

  if (nextPage <= pagesCount) {
    here.searchParams.set('page', String(nextPage));
    history.pushState({}, document.title, here.href);
    try {
      await fetchNextPage(isLast);
    } finally {
      btn.dataset.loading = '0';
    }
  }
});

// Works with dynamic content via event delegation
function initPageClick() {
  // If you have a stable wrapper, use it instead of document for better perf:
  // const root = document.querySelector('[data-product-list]');
  const root = document;

  root.addEventListener('click', (e) => {
    const product = e.target.closest('[data-product-grid]');
    if (!product || !root.contains(product)) return;

    // If you truly want to block multiple pushes for the same element in one session, keep this.
    // Otherwise remove this guard.
    if (product.classList.contains('initialised')) return;

    const page = product.getAttribute('data-page');
    const prodId = product.querySelector('.product-card')?.getAttribute('data-product-id');

    const url = new URL(location.href);
    if (page) url.searchParams.set('page', page);
    if (prodId) url.searchParams.set('product', prodId);

    history.pushState(null, document.title, url.href);

    product.classList.add('initialised');
  }, { passive: true });
}

// Collection Spot Resize

function collectionSpotsResize() {

    var contentContainers = document.querySelectorAll('#hero-collection__image_container .hero-image--container');

    contentContainers.forEach((container) => {
      var height = document.querySelector('.product-card__media').clientHeight;
      container.style.height = height + 'px';
    });
}

// Starts Collection Loading Animation

function startCollectionLoad() {
  var collectionElement = document.querySelector('dynamic-product-search.collection');
  var docElement = document.querySelector('html');
  collectionElement.classList.add("is-loading");
  docElement.classList.add("no-scroll");
  
}

// Ends Collection Loading Animation

function endCollectionLoad() {
  var collectionElement = document.querySelector('dynamic-product-search.collection');
  var docElement = document.querySelector('html');
  collectionElement.classList.remove("is-loading");
  docElement.classList.remove("no-scroll");
}

// Initialise Custom Sort Filter

function sortInit() {
  let radioVal;
  const radios = document.querySelectorAll('input[name="sort_by"]');
  radios.forEach(radio => {
    radio.addEventListener('click', function () {
      radioVal = radio.value;
      document.getElementById('SortBy').value=radioVal;
      radios.forEach(option => {
        option.removeAttribute('checked');
      });
      this.setAttribute('checked', '')
    });
  });
}

// Updates Product Count on PDP

function updateProductsLoaded(products) {

  var totalProducts = parseInt(document.getElementById('loaded-products').innerHTML) + products

  document.getElementById('loaded-products').innerHTML = totalProducts
}

// Initialises PDP Resize Buttons

function resizeButtons(e) {


var gridButtons = document.querySelectorAll('.collection-main__bar--grid [data-grid]');

gridButtons.forEach(button => {
  button.removeAttribute('selected')
});

if (e == 'initialLoad') {
  var storageState = sessionStorage.getItem('grid');
  if (storageState == 'enabled') {
    document.querySelector('.collection-main__bar--grid [data-grid="1"]').setAttribute('selected', '');
    document.querySelector('.collection-main__bar--grid [data-grid="2"]').removeAttribute('selected');
  } else {
    document.querySelector('.collection-main__bar--grid [data-grid="2"]').setAttribute('selected', '');
    document.querySelector('.collection-main__bar--grid [data-grid="1"]').removeAttribute('selected');
  }
}

gridButtons.forEach(button => {
  button.addEventListener('click', function () {

    gridButtons.forEach(button => {
      button.removeAttribute('selected')
    });

    if(button.getAttribute('data-grid') == 1) {
      prodResize(document, 1);
      sessionStorage.setItem('grid', 'enabled');
      button.setAttribute('selected', '');
      Shopify.ActiveProduct[0].scrollIntoView();
    } else {
      prodResize(document, 2);
      sessionStorage.removeItem('grid');
      button.setAttribute('selected', '');
      Shopify.ActiveProduct[0].scrollIntoView();
    }
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  });
});

}

// Function for resizing PDP content

function prodResize(doc ,key) {
  var productGrid = doc.querySelectorAll('[data-product-grid]');

  if (key == 'loadMore') {
    var gridButtonActive = document.querySelector('.collection-main__bar--grid [data-grid][selected]');
    key = gridButtonActive.getAttribute('data-grid');
  }

  if (key == 'initalLoad') {
    var storageState = sessionStorage.getItem('grid');
    if (storageState == 'enabled') {
      key = 1
    }
  }

  var gridElem = document.querySelector('.collection__cards');

    if (key == 1) {
      gridElem.setAttribute('aria-view','1/1');
    } else if (key == 2) {
      gridElem.setAttribute('aria-view','1/2');
    }

}

document.addEventListener('collection:loaded', function() {
    console.log('test');
    prodResize(document, 'initalLoad');
    resizeButtons('initialLoad');
    collectionSpotsResize();
    toggleInit();
    initPageClick();
}, true);

document.addEventListener('collection:filters-applied', function() {
  console.log('filters updated');
  if (typeof toggleInit === 'function') toggleInit();
  if (typeof prodResize === 'function') prodResize(document, 'initalLoad');
  if (typeof resizeButtons === 'function') resizeButtons('initialLoad');
  if (typeof collectionSpotsResize === 'function') collectionSpotsResize();
  if (typeof initPageClick === 'function') initPageClick();
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

window.addEventListener('resize', function(event) {
    collectionSpotsResize();
}, true);

document.dispatchEvent(new CustomEvent("collection:loaded"));
